import { ptPT, type ChaveTexto } from './pt-PT.ts';

const dicionario: Record<string, string> = ptPT;

/**
 * Camada de internacionalização (RNF-024). Com um único idioma activo é quase
 * uma indirecção inútil — excepto que acrescentá-la depois obriga a percorrer
 * todos os ecrãs, e a experiência diz que isso não chega a acontecer.
 *
 * A chave em falta devolve a própria chave em vez de rebentar: um texto errado
 * num ecrã é um defeito; um ecrã em branco é uma sessão perdida.
 */
export function t(chave: ChaveTexto | string, valores?: Record<string, string | number>): string {
  const modelo = dicionario[chave];
  if (modelo === undefined) {
    if (import.meta.env?.DEV) console.warn(`[i18n] chave em falta: ${chave}`);
    return chave;
  }
  if (!valores) return modelo;
  return modelo.replace(/\{(\w+)\}/g, (_todo, nome: string) =>
    nome in valores ? String(valores[nome]) : `{${nome}}`,
  );
}

export const idiomaActivo = 'pt-PT';
